module.exports = "https://static.wmbcdn.com/uniweb/images/980e61a18d683a4720efb7f0c2273c3a.svg";